import { toText, printf, toConsole, replace, fromBase64String, split as split_1, isNullOrWhiteSpace, compare } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { defaultArg, value as value_2, some, ofNullable } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { tryPick, map, item } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { FSharpRef, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { getUnionCases, makeUnion, name, string_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { uncurry3, defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { parse, tryParse, minValue, fromDateTime, toString } from "../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { utcNow, now } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { string, fail, succeed, andThen } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";

/**
 * Is str2 contained within str1? IContained for case Insensitive
 * <example>
 * For example:
 * <code>
 * "this is a test for you" |> strIContains "test" // true
 * "this is a Test for you" |> strIContains "test" // true
 * "this is a test for you" |> strIContains "Test" // true
 * "this is a test for you" |> strIContains "crest" // false
 * </code>
 * </example>
 */
export function strIContains(str2, str1) {
    const lower1 = str1.toLocaleLowerCase();
    const lower2 = str2.toLocaleLowerCase();
    return lower1.indexOf(lower2) >= 0;
}

/**
 * Case insensitive, culture invariant, string equals test
 */
export function strIEq(str1, str2) {
    return compare(str1, str2, 3) === 0;
}

/**
 * Helper function that tests whether the string is null, empty or just whitespace
 */
export function tryStr(str) {
    if (!isNullOrWhiteSpace(str)) {
        return str;
    }
    else {
        return undefined;
    }
}

export function tryNull(x) {
    return ofNullable(x);
}

/**
 * Helper function that wraps your function and argument in a try ... with and returns an option
 */
export function tryWith(f, x) {
    try {
        return new FSharpResult$2(0, [f(x)]);
    }
    catch (e) {
        return new FSharpResult$2(1, [e]);
    }
}

export function isPtgEmail(email) {
    if (email.trim().toLocaleLowerCase().endsWith("ptg.no") ? true : email.trim().toLocaleLowerCase().endsWith("ptguk.com")) {
        return true;
    }
    else {
        return email.trim().toLocaleLowerCase().endsWith("buskerudkulde.no");
    }
}

/**
 * Takes a DataUrl string and returns just the base64 encoded content: see
 * <a href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs">mdn</a>
 */
export function urlDataToCleanBase64(base64) {
    try {
        const split = split_1(base64, [","], undefined, 0);
        return (split.length > 1) ? item(1, split) : base64;
    }
    catch (matchValue) {
        return base64;
    }
}

/**
 * Takes a DataUrl string and returns just the base64 encoded content: see
 * <a href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs">mdn</a>
 */
export function tryUrlDataToCleanBase64(base64) {
    try {
        const split = split_1(base64, [","], undefined, 0);
        return (split.length > 1) ? (new FSharpResult$2(0, [item(1, split)])) : (new FSharpResult$2(1, [new Error("Does not contain \',\'")]));
    }
    catch (ex) {
        return new FSharpResult$2(1, [ex]);
    }
}

export const urlDataBytes = (arg) => fromBase64String(urlDataToCleanBase64(arg));

export class Environment extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Production", "Demo", "Staging", "Dev", "Tilt"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "demo" : ((this$.tag === 2) ? "staging" : ((this$.tag === 3) ? "development" : ((this$.tag === 4) ? "tilt" : "production")));
    }
}

export function Environment_$reflection() {
    return union_type("Shared.Environment", [], Environment, () => [[], [], [], [], []]);
}

/**
 * Expects a base64 encoded string
 */
export function UrlSafeB64_encode(s) {
    return replace(replace(replace(s, "+", "."), "/", "_"), "=", "-");
}

/**
 * Expects a base64 |> UrlSafeB64.encode encoded string
 */
export function UrlSafeB64_decode(s) {
    return replace(replace(replace(s, ".", "+"), "_", "/"), "-", "=");
}

/**
 * Calls the applied function, expecting that it can throw exceptions, and wraps either case in a result
 */
export function Result_catch(f, x) {
    try {
        return new FSharpResult$2(0, [f(x)]);
    }
    catch (e) {
        return new FSharpResult$2(1, [e]);
    }
}

export function Result_iterError(f, res) {
    if (res.tag === 1) {
        f(res.fields[0]);
    }
}

export function Result_mapError(f, res) {
    if (res.tag === 1) {
        return new FSharpResult$2(1, [f(res.fields[0])]);
    }
    else {
        return new FSharpResult$2(0, [res.fields[0]]);
    }
}

export function Result_tryError(res) {
    if (res.tag === 1) {
        return some(res.fields[0]);
    }
    else {
        return undefined;
    }
}

/**
 * Wraps your function in try .. with
 */
export function Option_catch(f, x) {
    try {
        return some(f(x));
    }
    catch (matchValue) {
        return undefined;
    }
}

export function Nullable_map(f, x) {
    if (x != null) {
        return f(value_2(x));
    }
    else {
        return defaultOf();
    }
}

export function Nullable_orElse(ifNull, nullable) {
    if (nullable != null) {
        return nullable;
    }
    else {
        return ifNull;
    }
}

export function Nullable_orElseWith(ifNullThunk, nullable) {
    if (nullable != null) {
        return nullable;
    }
    else {
        return ifNullThunk();
    }
}

export function String_replace(oldValue, newValue, source) {
    return replace(source, oldValue, newValue);
}

/**
 * Formats DateOnly as "yyyy-MM-dd", e.g.: "2024-10-28"
 */
export function DateOnly_iso(date) {
    return toString(date, "o", {});
}

export function DateOnly_now() {
    return fromDateTime(now());
}

export function DateOnly_utcNow() {
    return fromDateTime(utcNow());
}

export const DateOnly_decoder = (path_2) => ((value_1) => andThen(uncurry3((dateStr) => {
    toConsole(printf("DECODING DateOnly: %s"))(dateStr);
    let matchValue;
    let outArg = minValue();
    matchValue = [tryParse(dateStr, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return (arg10$0040) => ((arg20$0040_1) => succeed(matchValue[1], arg10$0040, arg20$0040_1));
    }
    else {
        return (path_1) => ((arg20$0040) => fail(`Expecting dateOnly but got "${dateStr}"`, path_1, arg20$0040));
    }
}), string, path_2, value_1));

export function DateOnly_encoder(dateOnly) {
    return DateOnly_iso(dateOnly);
}

export const DateOnly_tryParse = (x) => Option_catch(parse, x);

export class AuditLogs_Actions_Action extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Create", "Update", "Delete"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "update" : ((this$.tag === 2) ? "delete" : "create");
    }
}

export function AuditLogs_Actions_Action_$reflection() {
    return union_type("Shared.AuditLogs.Actions.Action", [], AuditLogs_Actions_Action, () => [[], [], []]);
}

export function AuditLogs_Actions_Action__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        default:
            return 1;
    }
}

export function AuditLogs_Actions_FromId(id) {
    switch (id) {
        case 1:
            return new AuditLogs_Actions_Action(0, []);
        case 2:
            return new AuditLogs_Actions_Action(1, []);
        case 3:
            return new AuditLogs_Actions_Action(2, []);
        default:
            return new AuditLogs_Actions_Action(1, []);
    }
}

export class Localization_Language extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Norwegian", "English"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "en" : "no-nb";
    }
}

export function Localization_Language_$reflection() {
    return union_type("Shared.Localization.Language", [], Localization_Language, () => [[], []]);
}

export function Localization_Language_FromString_Z721C83C5(str) {
    const matchValue = str.toLocaleLowerCase();
    switch (matchValue) {
        case "en":
            return new Localization_Language(1, []);
        default:
            return new Localization_Language(0, []);
    }
}

export const Economy_defaultMinYear = 2004;

export class Economy_TransactionType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Invoice", "CreditNote"];
    }
}

export function Economy_TransactionType_$reflection() {
    return union_type("Shared.Economy.TransactionType", [], Economy_TransactionType, () => [[], []]);
}

export function Economy_TransactionType__get_Id(this$) {
    if (this$.tag === 1) {
        return "credit-node";
    }
    else {
        return "invoice";
    }
}

export function Economy_TransactionType_TryFromId_Z721C83C5(id) {
    switch (id) {
        case "invoice":
            return new FSharpResult$2(0, [new Economy_TransactionType(0, [])]);
        case "credit-node":
            return new FSharpResult$2(0, [new Economy_TransactionType(1, [])]);
        default:
            return new FSharpResult$2(1, [toText(printf("Invalid transaction type id: %s"))(id)]);
    }
}

export class Orders_OrderStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Open", "Closed"];
    }
}

export function Orders_OrderStatus_$reflection() {
    return union_type("Shared.Orders.OrderStatus", [], Orders_OrderStatus, () => [[], []]);
}

export function Orders_OrderStatus__ToString_12C6553D(this$, lang) {
    if (lang.tag === 1) {
        if (this$.tag === 1) {
            return "Closed";
        }
        else {
            return "Open";
        }
    }
    else if (this$.tag === 1) {
        return "Lukket";
    }
    else {
        return "Åpen";
    }
}

export function Orders_OrderStatus__get_Id(this$) {
    if (this$.tag === 1) {
        return 2;
    }
    else {
        return 1;
    }
}

export function Orders_OrderStatus_FromId_Z524259A4(id) {
    switch (id) {
        case 1:
            return new Orders_OrderStatus(0, []);
        case 2:
            return new Orders_OrderStatus(1, []);
        default:
            return undefined;
    }
}

export class Orders_OrderType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["All", "Service", "Sale", "Project", "Warranty"];
    }
}

export function Orders_OrderType_$reflection() {
    return union_type("Shared.Orders.OrderType", [], Orders_OrderType, () => [[], [], [], [], []]);
}

export function Orders_OrderType__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        default:
            return -1;
    }
}

export function Orders_OrderType__ToLocalizedString_12C6553D(this$, lang) {
    switch (this$.tag) {
        case 1:
            return "Service";
        case 2:
            if (lang.tag === 1) {
                return "Sale";
            }
            else {
                return "Salg";
            }
        case 3:
            if (lang.tag === 1) {
                return "Project";
            }
            else {
                return "Prosjekt";
            }
        case 4:
            if (lang.tag === 1) {
                return "Warranty";
            }
            else {
                return "Garanti";
            }
        default:
            if (lang.tag === 1) {
                return "All";
            }
            else {
                return "Alle";
            }
    }
}

export function Orders_OrderType_get_AllCases() {
    return [new Orders_OrderType(0, []), new Orders_OrderType(1, []), new Orders_OrderType(2, []), new Orders_OrderType(3, []), new Orders_OrderType(4, [])];
}

export function Orders_OrderType_FromId_Z524259A4(x) {
    switch (x) {
        case 1:
            return new Orders_OrderType(1, []);
        case 2:
            return new Orders_OrderType(2, []);
        case 3:
            return new Orders_OrderType(3, []);
        case 4:
            return new Orders_OrderType(4, []);
        default:
            return new Orders_OrderType(0, []);
    }
}

export class GasReportType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FGas", "Oil", "Ammonia", "CO2", "FlammableCoolants"];
    }
}

export function GasReportType_$reflection() {
    return union_type("Shared.GasReportType", [], GasReportType, () => [[], [], [], [], []]);
}

export function GasReportType__ToString_12C6553D(this$, lang) {
    if (lang.tag === 1) {
        switch (this$.tag) {
            case 1:
                return "Oil";
            case 2:
                return "Ammonia";
            case 3:
                return "CO2";
            case 4:
                return "Flammable refrigerants";
            default:
                return "F-gas";
        }
    }
    else {
        switch (this$.tag) {
            case 1:
                return "Olje";
            case 2:
                return "Ammoniakk";
            case 3:
                return "CO2";
            case 4:
                return "Brannfarlige kjølemidler";
            default:
                return "F-gass";
        }
    }
}

export function GasReportType__get_VismaSourceId(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        default:
            return 1;
    }
}

export function GasReportType__get_GenerateChecklists(this$) {
    if (this$.tag === 0) {
        return true;
    }
    else {
        return false;
    }
}

export function GasReportType_Label_51614D81(gasType) {
    switch (gasType.tag) {
        case 1:
            return "oil";
        case 2:
            return "ammonia";
        case 3:
            return "co2";
        case 4:
            return "flammable-coolants";
        default:
            return "f-gas";
    }
}

export function GasReportType_FromVismaSourceId_Z524259A4(x) {
    switch (x) {
        case 2:
            return new GasReportType(1, []);
        case 3:
            return new GasReportType(2, []);
        case 4:
            return new GasReportType(3, []);
        case 5:
            return new GasReportType(4, []);
        default:
            return new GasReportType(0, []);
    }
}

export function GasReportType_get_All() {
    return [new GasReportType(0, []), new GasReportType(1, []), new GasReportType(2, []), new GasReportType(3, []), new GasReportType(4, [])];
}

export class GasReportTypeAction extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Fill", "Drain", "Check"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Nedtapping" : ((this$.tag === 2) ? "Sjekk" : "Fylling");
    }
}

export function GasReportTypeAction_$reflection() {
    return union_type("Shared.GasReportTypeAction", [], GasReportTypeAction, () => [[], [], []]);
}

export function GasReportTypeAction__ToLocalizedString_12C6553D(this$, lang) {
    switch (this$.tag) {
        case 1:
            if (lang.tag === 1) {
                return "Drain";
            }
            else {
                return "Nedtapping";
            }
        case 2:
            if (lang.tag === 1) {
                return "Check";
            }
            else {
                return "Sjekk";
            }
        default:
            if (lang.tag === 1) {
                return "Fill";
            }
            else {
                return "Fylling";
            }
    }
}

export function GasReportTypeAction__ToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        default:
            return 1;
    }
}

export function GasReportTypeAction_FromInt_Z524259A4(x) {
    switch (x) {
        case 1:
            return new GasReportTypeAction(0, []);
        case 2:
            return new GasReportTypeAction(1, []);
        default:
            return new GasReportTypeAction(2, []);
    }
}

export class ServiceType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PeriodicalControl", "YearlyService", "TwoAndAHalfYearControl", "TwoAndAHalfYearControlIncludingService", "FiveYearControl", "FiveYearControlIncludingService", "FiveThousandHoursControl", "TenThousandHoursControl", "TwentyFiveThousandHoursControl", "FiftyThousandHoursControl", "OneHundredThousandHoursControl", "Repair", "Upgrade", "Modification", "LeakControl", "FGasReport", "Startup", "Other"];
    }
}

export function ServiceType_$reflection() {
    return union_type("Shared.ServiceType", [], ServiceType, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [["Item", string_type]]]);
}

/**
 * For pretty printing
 */
export function ServiceType__ToString_12C6553D(this$, lang) {
    if (lang.tag === 1) {
        switch (this$.tag) {
            case 1:
                return "Yearly service";
            case 2:
                return "2.5 year control";
            case 3:
                return "2.5 year control, including service";
            case 4:
                return "5 year control";
            case 5:
                return "5 year control, including service";
            case 6:
                return "5,000 hour control";
            case 7:
                return "10,000 hour control";
            case 8:
                return "25,000 hour control";
            case 9:
                return "50,000 hour control";
            case 10:
                return "100,000 hour control";
            case 11:
                return "Repair";
            case 12:
                return "Upgrade";
            case 13:
                return "Modification";
            case 14:
                return "Leak control";
            case 15:
                return "F-gass report";
            case 16:
                return "Startup";
            case 17: {
                const str_2 = this$.fields[0];
                if (isNullOrWhiteSpace(str_2)) {
                    return "Other";
                }
                else {
                    return str_2;
                }
            }
            default:
                return "Periodical control";
        }
    }
    else {
        switch (this$.tag) {
            case 1:
                return "Årlig service";
            case 2:
                return "2,5 års kontroll";
            case 3:
                return "2,5 års kontroll, inkl. service";
            case 4:
                return "5 års kontroll";
            case 5:
                return "5 års kontroll, inkl. service";
            case 6:
                return "5.000 timers kontroll";
            case 7:
                return "10.000 timers kontroll";
            case 8:
                return "25.000 timers kontroll";
            case 9:
                return "50.000 timers kontroll";
            case 10:
                return "100.000 timers kontroll";
            case 11:
                return "Reparasjon";
            case 12:
                return "Oppgradering";
            case 13:
                return "Modifikasjon";
            case 14:
                return "Lekkasje kontroll";
            case 15:
                return "F-gass rapportering";
            case 16:
                return "Oppstart og igangkjøring";
            case 17: {
                const str = this$.fields[0];
                if (isNullOrWhiteSpace(str)) {
                    return "Annet";
                }
                else {
                    return str;
                }
            }
            default:
                return "Periodisk kontroll";
        }
    }
}

export function ServiceType__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 7;
        case 7:
            return 8;
        case 8:
            return 9;
        case 9:
            return 10;
        case 10:
            return 11;
        case 11:
            return 12;
        case 12:
            return 13;
        case 13:
            return 14;
        case 14:
            return 15;
        case 15:
            return 16;
        case 16:
            return 17;
        case 17:
            return 18;
        default:
            return 1;
    }
}

export function ServiceType_FromId_88FA7A4(id, otherStr) {
    switch (id) {
        case 1:
            return new ServiceType(0, []);
        case 2:
            return new ServiceType(1, []);
        case 3:
            return new ServiceType(2, []);
        case 4:
            return new ServiceType(3, []);
        case 5:
            return new ServiceType(4, []);
        case 6:
            return new ServiceType(5, []);
        case 7:
            return new ServiceType(6, []);
        case 8:
            return new ServiceType(7, []);
        case 9:
            return new ServiceType(8, []);
        case 10:
            return new ServiceType(9, []);
        case 11:
            return new ServiceType(10, []);
        case 12:
            return new ServiceType(11, []);
        case 13:
            return new ServiceType(12, []);
        case 14:
            return new ServiceType(13, []);
        case 15:
            return new ServiceType(14, []);
        case 16:
            return new ServiceType(15, []);
        case 17:
            return new ServiceType(16, []);
        case 18:
            return new ServiceType(17, [defaultArg(otherStr, "")]);
        default:
            return new ServiceType(0, []);
    }
}

export function ServiceType_get_All() {
    return [new ServiceType(0, []), new ServiceType(1, []), new ServiceType(2, []), new ServiceType(3, []), new ServiceType(4, []), new ServiceType(5, []), new ServiceType(6, []), new ServiceType(7, []), new ServiceType(8, []), new ServiceType(9, []), new ServiceType(10, []), new ServiceType(11, []), new ServiceType(12, []), new ServiceType(13, []), new ServiceType(14, []), new ServiceType(15, []), new ServiceType(16, []), new ServiceType(17, [""])];
}

export function ServiceType_AllRecords_12C6553D(language) {
    return map((t) => ({
        id: ServiceType__get_Id(t),
        label: ServiceType__ToString_12C6553D(t, language),
        "type\'": t,
    }), ServiceType_get_All());
}

export class ServiceStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Planned", "DateConfirmed", "Finished", "Cancelled"];
    }
}

export function ServiceStatus_$reflection() {
    return union_type("Shared.ServiceStatus", [], ServiceStatus, () => [[], [], [], []]);
}

/**
 * For pretty printing
 */
export function ServiceStatus__ToString_12C6553D(this$, locale) {
    if (locale.tag === 1) {
        switch (this$.tag) {
            case 1:
                return "Date Confirmed";
            case 2:
                return "Finished";
            case 3:
                return "Cancelled";
            default:
                return "Planned";
        }
    }
    else {
        switch (this$.tag) {
            case 1:
                return "Dato bekreftet";
            case 2:
                return "Ferdig";
            case 3:
                return "Avlyst";
            default:
                return "Planlagt";
        }
    }
}

export function ServiceStatus__ToFormattedString(this$) {
    switch (this$.tag) {
        case 1:
            return "date-confirmed";
        case 2:
            return "finished";
        case 3:
            return "cancelled";
        default:
            return "planned";
    }
}

export function ServiceStatus_Color_Z43893D55(status) {
    switch (status.tag) {
        case 2:
            return "var(--alerts-positive-dark)";
        case 3:
            return "var(--alerts-warning-minor-dark)";
        default:
            return "var(--alerts-information-dark)";
    }
}

export function ServiceStatus_BackgroundColor_Z43893D55(status) {
    switch (status.tag) {
        case 2:
            return "var(--alerts-positive-light)";
        case 3:
            return "var(--alerts-warning-minor-light)";
        default:
            return "var(--alerts-information-light)";
    }
}

/**
 * Takes a formatted string and returns the union. Use the ToFormattedString method.
 */
export function ServiceStatus_FromString_Z721C83C5(str) {
    const _arg = str.trim().toLocaleLowerCase();
    switch (_arg) {
        case "planned":
            return new ServiceStatus(0, []);
        case "date-confirmed":
            return new ServiceStatus(1, []);
        case "finished":
            return new ServiceStatus(2, []);
        case "cancelled":
            return new ServiceStatus(3, []);
        default:
            return new ServiceStatus(0, []);
    }
}

export class MarketCategory extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CommercialAndClimate", "MarineAndIndustry"];
    }
}

export function MarketCategory_$reflection() {
    return union_type("Shared.MarketCategory", [], MarketCategory, () => [[], []]);
}

export function MarketCategory_FromId_Z524259A4(x) {
    if (x === 2) {
        return new MarketCategory(1, []);
    }
    else {
        return new MarketCategory(0, []);
    }
}

export function MarketCategory__ToId(this$) {
    if (this$.tag === 1) {
        return 2;
    }
    else {
        return 1;
    }
}

/**
 * "+47 40104877" if cc exists, else "40104877"
 */
export function Account_formatPhone(cc, number) {
    if (isNullOrWhiteSpace(cc)) {
        return number;
    }
    else {
        return `+${cc} ${number}`;
    }
}

export class Account_Audit_Prop extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Id", "Email", "FirstName", "LastName", "Salt", "Password", "IsAdmin", "IsSuperAdmin", "IsPtg", "TwoFactor", "ForcedTfa", "Enabled", "Activated", "Locale", "PhoneCC", "Phone", "TicketSystemAccess"];
    }
}

export function Account_Audit_Prop_$reflection() {
    return union_type("Shared.Account.Audit.Prop", [], Account_Audit_Prop, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function Account_Audit_Prop_ToColumnId_2CB9DEF3(column) {
    switch (column.tag) {
        case 1:
            throw new Error("todo");
        case 2:
            throw new Error("todo");
        case 3:
            throw new Error("todo");
        case 4:
            throw new Error("todo");
        case 5:
            throw new Error("todo");
        case 6:
            throw new Error("todo");
        case 7:
            throw new Error("todo");
        case 8:
            throw new Error("todo");
        case 9:
            throw new Error("todo");
        case 10:
            throw new Error("todo");
        case 11:
            return 11;
        case 12:
            throw new Error("todo");
        case 13:
            throw new Error("todo");
        case 14:
            throw new Error("todo");
        case 15:
            throw new Error("todo");
        case 16:
            throw new Error("todo");
        default:
            return 0;
    }
}

export const Documents_maxUploadDocumentCount = 50;

export const Documents_maxUploadSizeKB = 1000 * 150;

export class Documents_DocumentSource extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Visma", "Evatic", "KundeWeb"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Evatic" : ((this$.tag === 2) ? "KundeWeb" : "Visma");
    }
}

export function Documents_DocumentSource_$reflection() {
    return union_type("Shared.Documents.DocumentSource", [], Documents_DocumentSource, () => [[], [], []]);
}

export function Documents_DocumentSource__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        default:
            return 1;
    }
}

export function Documents_DocumentSource_FromId_Z524259A4(x) {
    switch (x) {
        case 1:
            return new Documents_DocumentSource(0, []);
        case 2:
            return new Documents_DocumentSource(1, []);
        default:
            return new Documents_DocumentSource(2, []);
    }
}

export class Documents_TreeSyncRule extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CategoryLeakAndFill", "CategoryChecklist", "CategoryFDV", "CategoryRoutineAndSafety"];
    }
}

export function Documents_TreeSyncRule_$reflection() {
    return union_type("Shared.Documents.TreeSyncRule", [], Documents_TreeSyncRule, () => [[], [], [], []]);
}

export function Documents_TreeSyncRule_AllRules() {
    return [new Documents_TreeSyncRule(0, []), new Documents_TreeSyncRule(1, []), new Documents_TreeSyncRule(2, []), new Documents_TreeSyncRule(3, [])];
}

export function Documents_TreeSyncRule__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        default:
            return 1;
    }
}

export function Documents_TreeSyncRule_TryFromId_Z524259A4(x) {
    switch (x) {
        case 1:
            return new Documents_TreeSyncRule(0, []);
        case 2:
            return new Documents_TreeSyncRule(1, []);
        case 3:
            return new Documents_TreeSyncRule(2, []);
        case 4:
            return new Documents_TreeSyncRule(3, []);
        default:
            return undefined;
    }
}

export function Documents_TreeSyncRule__ToLocalizedString_12C6553D(this$, lang) {
    if (lang.tag === 1) {
        const category_1 = (this$.tag === 1) ? "Service/checklists and statusreports" : ((this$.tag === 2) ? "FDV, startup and handover" : ((this$.tag === 3) ? "Routines and safety" : "Leak control and filling"));
        return toText(printf("%s documents"))(category_1);
    }
    else {
        const category = (this$.tag === 1) ? "Service/sjekklister og tilstandsrapporter" : ((this$.tag === 2) ? "FDV, igangkjøring og overlevering" : ((this$.tag === 3) ? "Rutiner og sikkerhet" : "Lekkasjekontrol og fylling"));
        return toText(printf("%s dokumenter"))(category);
    }
}

export class Documents_Audit_Prop extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DocumentType", "DocumentContentId", "CustomerId", "VismaDocNo", "VismaVerNo", "VismaLnNo", "SourceCompanyId", "CategoryId", "Title", "Created", "Uploaded", "MachineId", "SourceSystem", "DocNumber", "Version", "IsDeleted", "IsHidden", "CategoryTreeId", "ManuallyMoved", "ManuallyMovedFrom"];
    }
}

export function Documents_Audit_Prop_$reflection() {
    return union_type("Shared.Documents.Audit.Prop", [], Documents_Audit_Prop, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function Documents_Audit_Prop__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 7;
        case 7:
            return 8;
        case 8:
            return 9;
        case 9:
            return 10;
        case 10:
            return 11;
        case 11:
            return 12;
        case 12:
            return 13;
        case 13:
            return 14;
        case 14:
            return 15;
        case 15:
            return 16;
        case 16:
            return 17;
        case 17:
            return 18;
        case 18:
            return 19;
        case 19:
            return 20;
        default:
            return 1;
    }
}

export function Documents_Audit_Prop_ToColumnId_65ECBD2E(column) {
    switch (column.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 7;
        case 7:
            return 8;
        case 8:
            return 9;
        case 9:
            return 10;
        case 10:
            return 11;
        case 11:
            return 12;
        case 12:
            return 13;
        case 13:
            return 14;
        case 14:
            return 15;
        case 15:
            return 16;
        case 16:
            return 17;
        case 17:
            return 18;
        case 18:
            return 19;
        case 19:
            return 20;
        default:
            return 1;
    }
}

export function Documents_Audit_Prop_FromColumnId_Z524259A4(columnId) {
    switch (columnId) {
        case 1:
            return new Documents_Audit_Prop(0, []);
        case 2:
            return new Documents_Audit_Prop(1, []);
        case 3:
            return new Documents_Audit_Prop(2, []);
        case 4:
            return new Documents_Audit_Prop(3, []);
        case 5:
            return new Documents_Audit_Prop(4, []);
        case 6:
            return new Documents_Audit_Prop(5, []);
        case 7:
            return new Documents_Audit_Prop(6, []);
        case 8:
            return new Documents_Audit_Prop(7, []);
        case 9:
            return new Documents_Audit_Prop(8, []);
        case 10:
            return new Documents_Audit_Prop(9, []);
        case 11:
            return new Documents_Audit_Prop(10, []);
        case 12:
            return new Documents_Audit_Prop(11, []);
        case 13:
            return new Documents_Audit_Prop(12, []);
        case 14:
            return new Documents_Audit_Prop(13, []);
        case 15:
            return new Documents_Audit_Prop(14, []);
        case 16:
            return new Documents_Audit_Prop(15, []);
        case 17:
            return new Documents_Audit_Prop(16, []);
        case 18:
            return new Documents_Audit_Prop(17, []);
        case 19:
            return new Documents_Audit_Prop(18, []);
        case 20:
            return new Documents_Audit_Prop(19, []);
        default:
            return undefined;
    }
}

export function Documents_Audit_Prop_ToString(lang, prop) {
    if (lang.tag === 1) {
        switch (prop.tag) {
            case 1:
                return "Content id";
            case 2:
                return "Customer id";
            case 3:
                return "Visma doc nr";
            case 4:
                return "Visma ver nr";
            case 5:
                return "Visma line nr";
            case 6:
                return "Company id";
            case 7:
                return "Category id";
            case 8:
                return "Title";
            case 9:
                return "Created";
            case 10:
                return "Uploaded";
            case 11:
                return "Machine id";
            case 12:
                return "Source system";
            case 13:
                return "Document number";
            case 14:
                return "Version";
            case 15:
                return "Deleted";
            case 16:
                return "Hidden";
            case 17:
                return "Categori";
            case 18:
                return "Manually moved";
            case 19:
                return "Manually moved from category";
            default:
                return "Document type";
        }
    }
    else {
        switch (prop.tag) {
            case 1:
                return "Innholds id";
            case 2:
                return "Kunde id";
            case 3:
                return "Visma doc nr";
            case 4:
                return "Visma ver nr";
            case 5:
                return "Visma linje nr";
            case 6:
                return "Selskaps id";
            case 7:
                return "Kategori id";
            case 8:
                return "Tittel";
            case 9:
                return "Opprettet";
            case 10:
                return "Opplastet";
            case 11:
                return "Maskin id";
            case 12:
                return "Kildesystem";
            case 13:
                return "Dokument nummer";
            case 14:
                return "Versjon";
            case 15:
                return "Slettet";
            case 16:
                return "Gjømt";
            case 17:
                return "Kategori";
            case 18:
                return "Manuelt flyttet";
            case 19:
                return "Manuelt flyttet fra kategori";
            default:
                return "Dokumenttype";
        }
    }
}

export function DocumentTrees_Audit_toString(lang, prop) {
    if (lang.tag === 1) {
        switch (prop) {
            case 0:
                return "Id";
            case 1:
                return "Category version";
            case 2:
                return "Norwegian category name";
            case 3:
                return "English category name";
            case 4:
                return "Category ID";
            case 5:
                return "Parent folder";
            case 6:
                return "Norwegian description";
            case 7:
                return "English description";
            case 8:
                return "Only visible for PTG";
            case 9:
                return "Allow direct upload";
            case 10:
                return "Row position";
            case 11:
                return "Enabled";
            case 12:
                return "Machine ID";
            case 13:
                return "Allow folder per machine";
            default:
                return "Error: Missing property";
        }
    }
    else {
        switch (prop) {
            case 0:
                return "Id";
            case 1:
                return "Kategoriversjon";
            case 2:
                return "Norsk kategorinavn";
            case 3:
                return "Engelsk kategorinavn";
            case 4:
                return "Kategori ID";
            case 5:
                return "Forelderkategori";
            case 6:
                return "Norsk beskrivelse";
            case 7:
                return "Engelsk beskrivelse";
            case 8:
                return "Kun synlig for PTG";
            case 9:
                return "Tillat direkte opplastning";
            case 10:
                return "Rad posisjon";
            case 11:
                return "Aktivert";
            case 12:
                return "Anleggs ID";
            case 13:
                return "Tillat mapper per anlegg";
            default:
                return "Feil: Manglende egenskap";
        }
    }
}

export function DocumentTreeVersions_Audit_toString(lang, prop) {
    if (lang.tag === 1) {
        switch (prop) {
            case 0:
                return "Id";
            case 1:
                return "Activated";
            default:
                return "Error: Missing property";
        }
    }
    else {
        switch (prop) {
            case 0:
                return "Id";
            case 1:
                return "Aktivert";
            default:
                return "Feil: Manglende egenskap";
        }
    }
}

/**
 * Validates abbrv. and returns optional error
 */
export function Company_validateAbbr(language, abbr) {
    const spaces = abbr.trim().indexOf(" ") >= 0;
    if (isNullOrWhiteSpace(abbr)) {
        return (language.tag === 1) ? "Abbrv. cannot be empty" : "Forkortelsen kan ikke være tom";
    }
    else if (spaces) {
        return (language.tag === 1) ? "Abbrv. cannot contain spaces" : "Forkortelser kan ikke inneholde mellomrom";
    }
    else {
        return undefined;
    }
}

/**
 * Helper function for defaulting to machine code when the name is empty. Puts an asterix(\*)
 * by the code to indicate that the name is missing and the code is used instead. Add foot
 * note for the \* to tell the user why the name is special
 */
export function Machine_getNameOrCode(nameAndCode) {
    if (isNullOrWhiteSpace(nameAndCode.name)) {
        return `*${nameAndCode.code}`;
    }
    else {
        return nameAndCode.name;
    }
}

export class Tickets_Category extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Automation", "Electrical", "Mechanical", "Oil", "Structure", "Other", "ServiceAndMaintenance"];
    }
}

export function Tickets_Category_$reflection() {
    return union_type("Shared.Tickets.Category", [], Tickets_Category, () => [[], [], [], [], [], [], []]);
}

export function Tickets_Category_FromId_Z524259A4(x) {
    switch (x) {
        case 1:
            return new Tickets_Category(0, []);
        case 2:
            return new Tickets_Category(1, []);
        case 3:
            return new Tickets_Category(2, []);
        case 4:
            return new Tickets_Category(3, []);
        case 5:
            return new Tickets_Category(4, []);
        case 6:
            return new Tickets_Category(5, []);
        default:
            return new Tickets_Category(6, []);
    }
}

export function Tickets_Category_All() {
    return [new Tickets_Category(0, []), new Tickets_Category(1, []), new Tickets_Category(2, []), new Tickets_Category(3, []), new Tickets_Category(4, []), new Tickets_Category(6, []), new Tickets_Category(5, [])];
}

export function Tickets_Category__get_Identifier(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 7;
        default:
            return 1;
    }
}

export class Tickets_Severity extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Critical", "Urgent", "High", "Medium", "Low", "Info"];
    }
}

export function Tickets_Severity_$reflection() {
    return union_type("Shared.Tickets.Severity", [], Tickets_Severity, () => [[], [], [], [], [], []]);
}

export function Tickets_Severity__ToString_12C6553D(this$, lang) {
    if (lang.tag === 1) {
        switch (this$.tag) {
            case 1:
                return "Urgent";
            case 2:
                return "High";
            case 3:
                return "Medium";
            case 4:
                return "Low";
            case 5:
                return "Info";
            default:
                return "Critical";
        }
    }
    else {
        switch (this$.tag) {
            case 1:
                return "Haster";
            case 2:
                return "Høy";
            case 3:
                return "Moderat";
            case 4:
                return "Lav";
            case 5:
                return "Info";
            default:
                return "Kritisk";
        }
    }
}

export function Tickets_Severity__get_Id(this$) {
    switch (this$.tag) {
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        case 5:
            return 5;
        case 0:
            return 6;
        default:
            return 1;
    }
}

export function Tickets_Severity__get_ColorCode(this$) {
    switch (this$.tag) {
        case 1:
            return "var(--alerts-critical-warning-dark)";
        case 2:
            return "var(--alerts-critical-warning-dark)";
        case 3:
            return "var(--alerts-warning-dark)";
        case 4:
            return "var(--alerts-warning-minor-dark)";
        case 5:
            return "var(--alerts-neutral-dark)";
        default:
            return "var(--alerts-critical-warning-dark)";
    }
}

export function Tickets_Severity__get_BackgroundColor(this$) {
    switch (this$.tag) {
        case 1:
            return "var(--alerts-critical-warning-light)";
        case 2:
            return "var(--alerts-critical-warning-light)";
        case 3:
            return "var(--alerts-warning-light)";
        case 4:
            return "var(--alerts-warning-minor-light)";
        case 5:
            return "var(--alerts-neutral-light)";
        default:
            return "var(--alerts-critical-warning-light)";
    }
}

/**
 * convert integer to severity, default to medium
 */
export function Tickets_Severity_FromId_Z524259A4(x) {
    switch (x) {
        case 1:
            return new Tickets_Severity(1, []);
        case 2:
            return new Tickets_Severity(2, []);
        case 4:
            return new Tickets_Severity(4, []);
        case 5:
            return new Tickets_Severity(5, []);
        case 6:
            return new Tickets_Severity(0, []);
        default:
            return new Tickets_Severity(3, []);
    }
}

export function Tickets_Severity_All() {
    return [new Tickets_Severity(5, []), new Tickets_Severity(4, []), new Tickets_Severity(3, []), new Tickets_Severity(2, []), new Tickets_Severity(1, [])];
}

export class Tickets_Segment extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Marine", "Industry", "Commercial", "Climate"];
    }
}

export function Tickets_Segment_$reflection() {
    return union_type("Shared.Tickets.Segment", [], Tickets_Segment, () => [[], [], [], []]);
}

export function Tickets_Segment__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        default:
            return 1;
    }
}

export function Tickets_Segment_FromId_Z524259A4(x) {
    switch (x) {
        case 1:
            return new Tickets_Segment(0, []);
        case 2:
            return new Tickets_Segment(1, []);
        case 3:
            return new Tickets_Segment(2, []);
        default:
            return new Tickets_Segment(3, []);
    }
}

export function Tickets_Segment_All() {
    return [new Tickets_Segment(0, []), new Tickets_Segment(1, []), new Tickets_Segment(2, []), new Tickets_Segment(3, [])];
}

export class Tickets_TicketStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Open", "Reopened", "InProgress", "Hold", "Closed"];
    }
}

export function Tickets_TicketStatus_$reflection() {
    return union_type("Shared.Tickets.TicketStatus", [], Tickets_TicketStatus, () => [[], [], [], [], []]);
}

export function Tickets_TicketStatus__ToString_12C6553D(this$, lang) {
    if (lang.tag === 0) {
        switch (this$.tag) {
            case 1:
                return "Gjenåpnet";
            case 2:
                return "Behandles";
            case 3:
                return "Satt på hold";
            case 4:
                return "Avsluttet";
            default:
                return "Venter behandling";
        }
    }
    else {
        switch (this$.tag) {
            case 1:
                return "Reopened";
            case 2:
                return "In progress";
            case 3:
                return "Hold";
            case 4:
                return "Closed";
            default:
                return "Open";
        }
    }
}

export function Tickets_TicketStatus__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        default:
            return 1;
    }
}

export function Tickets_TicketStatus__get_Color(this$) {
    switch (this$.tag) {
        case 2:
            return "var(--alerts-information-dark)";
        case 3:
            return "var(--alerts-warning-dark)";
        case 1:
            return "var(--alerts-information-dark)";
        case 4:
            return "var(--alerts-positive-dark)";
        default:
            return "var(--alerts-neutral-dark)";
    }
}

export function Tickets_TicketStatus__get_BackgroundColor(this$) {
    switch (this$.tag) {
        case 2:
            return "var(--alerts-information-light)";
        case 3:
            return "var(--alerts-warning-light)";
        case 1:
            return "var(--alerts-information-light)";
        case 4:
            return "var(--alerts-positive-light)";
        default:
            return "var(--alerts-neutral-light)";
    }
}

/**
 * Convert id to type, default to open
 */
export function Tickets_TicketStatus_FromId_Z524259A4(x) {
    switch (x) {
        case 2:
            return new Tickets_TicketStatus(1, []);
        case 3:
            return new Tickets_TicketStatus(2, []);
        case 4:
            return new Tickets_TicketStatus(3, []);
        case 5:
            return new Tickets_TicketStatus(4, []);
        default:
            return new Tickets_TicketStatus(0, []);
    }
}

export function Tickets_TicketStatus_All() {
    return [new Tickets_TicketStatus(0, []), new Tickets_TicketStatus(2, []), new Tickets_TicketStatus(3, []), new Tickets_TicketStatus(4, []), new Tickets_TicketStatus(1, [])];
}

export class Tickets_TicketType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TechnicalSupport", "InspectionServiceRepair", "UpdateAndModification", "SpareParts", "StartupAndCommissioning", "Nonconformity", "WarrantyRequest", "InvoiceEconomy", "Other"];
    }
}

export function Tickets_TicketType_$reflection() {
    return union_type("Shared.Tickets.TicketType", [], Tickets_TicketType, () => [[], [], [], [], [], [], [], [], []]);
}

export function Tickets_TicketType__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 7;
        case 7:
            return 8;
        case 8:
            return 9;
        default:
            return 1;
    }
}

export function Tickets_TicketType_FromId_Z524259A4(x) {
    switch (x) {
        case 1:
            return new Tickets_TicketType(0, []);
        case 2:
            return new Tickets_TicketType(1, []);
        case 3:
            return new Tickets_TicketType(2, []);
        case 4:
            return new Tickets_TicketType(3, []);
        case 5:
            return new Tickets_TicketType(4, []);
        case 6:
            return new Tickets_TicketType(5, []);
        case 7:
            return new Tickets_TicketType(6, []);
        case 8:
            return new Tickets_TicketType(7, []);
        default:
            return new Tickets_TicketType(8, []);
    }
}

export function Tickets_TicketType_All() {
    return [new Tickets_TicketType(0, []), new Tickets_TicketType(1, []), new Tickets_TicketType(2, []), new Tickets_TicketType(3, []), new Tickets_TicketType(4, []), new Tickets_TicketType(5, []), new Tickets_TicketType(6, []), new Tickets_TicketType(7, []), new Tickets_TicketType(8, [])];
}

export class Tickets_UtilityClass extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["HeatPump", "IceSystem", "Cooler", "Thawing", "ControlSystem", "StoreSolutions", "Building", "Processing"];
    }
}

export function Tickets_UtilityClass_$reflection() {
    return union_type("Shared.Tickets.UtilityClass", [], Tickets_UtilityClass, () => [[], [], [], [], [], [], [], []]);
}

export function Tickets_UtilityClass_FromId_Z524259A4(x) {
    switch (x) {
        case 1:
            return new Tickets_UtilityClass(0, []);
        case 2:
            return new Tickets_UtilityClass(1, []);
        case 3:
            return new Tickets_UtilityClass(2, []);
        case 4:
            return new Tickets_UtilityClass(3, []);
        case 5:
            return new Tickets_UtilityClass(4, []);
        case 6:
            return new Tickets_UtilityClass(5, []);
        case 7:
            return new Tickets_UtilityClass(6, []);
        default:
            return new Tickets_UtilityClass(7, []);
    }
}

export function Tickets_UtilityClass_All() {
    return [new Tickets_UtilityClass(0, []), new Tickets_UtilityClass(1, []), new Tickets_UtilityClass(2, []), new Tickets_UtilityClass(3, []), new Tickets_UtilityClass(4, []), new Tickets_UtilityClass(5, []), new Tickets_UtilityClass(6, []), new Tickets_UtilityClass(7, [])];
}

export function Tickets_UtilityClass__get_Identifier(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 7;
        case 7:
            return 8;
        default:
            return 1;
    }
}

export class Tickets_WarrantyType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ReplaceParts", "RepairAndParts", "Documentation", "Repair", "RemoteSupport", "Inspection"];
    }
}

export function Tickets_WarrantyType_$reflection() {
    return union_type("Shared.Tickets.WarrantyType", [], Tickets_WarrantyType, () => [[], [], [], [], [], []]);
}

export function Tickets_WarrantyType_All() {
    return [new Tickets_WarrantyType(0, []), new Tickets_WarrantyType(1, []), new Tickets_WarrantyType(2, []), new Tickets_WarrantyType(3, []), new Tickets_WarrantyType(4, []), new Tickets_WarrantyType(5, [])];
}

export function Tickets_WarrantyType_FromId_Z524259A4(x) {
    switch (x) {
        case 2:
            return new Tickets_WarrantyType(1, []);
        case 3:
            return new Tickets_WarrantyType(2, []);
        case 4:
            return new Tickets_WarrantyType(3, []);
        case 5:
            return new Tickets_WarrantyType(4, []);
        case 6:
            return new Tickets_WarrantyType(5, []);
        default:
            return new Tickets_WarrantyType(0, []);
    }
}

export function Tickets_WarrantyType__get_Identifier(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        default:
            return 1;
    }
}

export class Tickets_Audit_Prop extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CustomerId", "ResponsibleId", "CreatedById", "Created", "CriticalOperationalHalt", "TicketType", "Segment", "Category", "Severity", "UtilityClass", "ShortDescription", "Description", "Description2", "WarrantyType", "WarrantyTypeText", "WarrantyReservation", "WarrantyReservationDescription", "Resolution", "Status", "CustomerOrderId", "VismaOrderNo", "SendUpdateEmail", "IsHidden", "ContactName", "ContactEmail", "ContactPhoneCountryCode", "ContactPhone"];
    }
}

export function Tickets_Audit_Prop_$reflection() {
    return union_type("Shared.Tickets.Audit.Prop", [], Tickets_Audit_Prop, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function Tickets_Audit_Prop__ToString_12C6553D(this$, locale) {
    if (locale.tag === 1) {
        switch (this$.tag) {
            case 1:
                return "responsible id";
            case 2:
                return "created by ";
            case 3:
                return "creation date";
            case 4:
                return "critical operational halt status";
            case 5:
                return "ticket type";
            case 6:
                return "segment";
            case 7:
                return "category";
            case 8:
                return "severity";
            case 9:
                return "utility class";
            case 10:
                return "short description";
            case 11:
                return "description";
            case 12:
                return "second description";
            case 13:
                return "warranty type";
            case 14:
                return "warranty text";
            case 15:
                return "warranty reservation";
            case 16:
                return "warranty reservation description";
            case 17:
                return "resolution";
            case 18:
                return "status";
            case 19:
                return "order number";
            case 20:
                return "visma order number";
            case 21:
                return "send update email";
            case 22:
                return "hidden";
            case 23:
                return "contacted by name";
            case 24:
                return "contacted by email";
            case 25:
                return "contacted by country calling code";
            case 26:
                return "contacted by phone number";
            default:
                return "customer";
        }
    }
    else {
        switch (this$.tag) {
            case 1:
                return "ansvarlig";
            case 2:
                return "oppretter";
            case 3:
                return "opprettelsesdato";
            case 4:
                return "kritisk opersjonsstansstatus";
            case 5:
                return "tickettype";
            case 6:
                return "segment";
            case 7:
                return "kategori";
            case 8:
                return "alvorlighetsgrad";
            case 9:
                return "utstyrsklasse";
            case 10:
                return "kort beskrivelse";
            case 11:
                return "detaljert beskrivelse";
            case 12:
                return "tileggsbeskrivelse";
            case 13:
                return "garantitype";
            case 14:
                return "garantitekst";
            case 15:
                return "reservasjon mot krav";
            case 16:
                return "reservasjonsgrunn";
            case 17:
                return "ferdistillelseskommentar";
            case 18:
                return "status";
            case 19:
                return "ordrenummer";
            case 20:
                return "visma ordrenummer";
            case 21:
                return "send oppdateringsmail";
            case 22:
                return "skjult";
            case 23:
                return "kontaktet av navn";
            case 24:
                return "kontaktet av email";
            case 25:
                return "kontaktet av landsnummer";
            case 26:
                return "kontaktet av telefonnummer";
            default:
                return "kunde";
        }
    }
}

export function Tickets_Audit_Prop_FromString_Z721C83C5(str) {
    switch (str) {
        case "CustomerId":
            return new Tickets_Audit_Prop(0, []);
        case "ResponsibleId":
            return new Tickets_Audit_Prop(1, []);
        case "CreatedById":
            return new Tickets_Audit_Prop(2, []);
        case "Created":
            return new Tickets_Audit_Prop(3, []);
        case "CriticalOperationalHalt":
            return new Tickets_Audit_Prop(4, []);
        case "TicketType":
            return new Tickets_Audit_Prop(5, []);
        case "Segment":
            return new Tickets_Audit_Prop(6, []);
        case "Category":
            return new Tickets_Audit_Prop(7, []);
        case "Severity":
            return new Tickets_Audit_Prop(8, []);
        case "UtilityClass":
            return new Tickets_Audit_Prop(9, []);
        case "ShortDescription":
            return new Tickets_Audit_Prop(10, []);
        case "Description":
            return new Tickets_Audit_Prop(11, []);
        case "Description2":
            return new Tickets_Audit_Prop(12, []);
        case "WarrantyType":
            return new Tickets_Audit_Prop(13, []);
        case "WarrantyTypeText":
            return new Tickets_Audit_Prop(14, []);
        case "WarrantyReservation":
            return new Tickets_Audit_Prop(15, []);
        case "WarrantyReservationDescription":
            return new Tickets_Audit_Prop(16, []);
        case "Resolution":
            return new Tickets_Audit_Prop(17, []);
        case "Status":
            return new Tickets_Audit_Prop(18, []);
        case "CustomerOrderId":
            return new Tickets_Audit_Prop(19, []);
        case "VismaOrderNo":
            return new Tickets_Audit_Prop(20, []);
        case "SendUpdateEmail":
            return new Tickets_Audit_Prop(21, []);
        case "IsHidden":
            return new Tickets_Audit_Prop(22, []);
        case "ContactName":
            return new Tickets_Audit_Prop(23, []);
        case "ContactEmail":
            return new Tickets_Audit_Prop(24, []);
        case "ContactPhoneCountryCode":
            return new Tickets_Audit_Prop(25, []);
        case "ContactPhone":
            return new Tickets_Audit_Prop(26, []);
        default:
            return undefined;
    }
}

export function Tickets_Audit_Prop_ToColumnId_182A0A5(column) {
    switch (column.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 7;
        case 7:
            return 8;
        case 8:
            return 9;
        case 9:
            return 10;
        case 10:
            return 11;
        case 11:
            return 12;
        case 12:
            return 13;
        case 13:
            return 14;
        case 14:
            return 15;
        case 15:
            return 16;
        case 16:
            return 17;
        case 17:
            return 18;
        case 18:
            return 19;
        case 20:
            return 20;
        case 21:
            return 21;
        case 22:
            return 22;
        case 23:
            return 23;
        case 24:
            return 24;
        case 25:
            return 25;
        case 26:
            return 26;
        case 19:
            return 27;
        default:
            return 1;
    }
}

export function Tickets_Audit_Prop_FromColumnId_Z524259A4(columnId) {
    switch (columnId) {
        case 1:
            return new Tickets_Audit_Prop(0, []);
        case 2:
            return new Tickets_Audit_Prop(1, []);
        case 3:
            return new Tickets_Audit_Prop(2, []);
        case 4:
            return new Tickets_Audit_Prop(3, []);
        case 5:
            return new Tickets_Audit_Prop(4, []);
        case 6:
            return new Tickets_Audit_Prop(5, []);
        case 7:
            return new Tickets_Audit_Prop(6, []);
        case 8:
            return new Tickets_Audit_Prop(7, []);
        case 9:
            return new Tickets_Audit_Prop(8, []);
        case 10:
            return new Tickets_Audit_Prop(9, []);
        case 11:
            return new Tickets_Audit_Prop(10, []);
        case 12:
            return new Tickets_Audit_Prop(11, []);
        case 13:
            return new Tickets_Audit_Prop(12, []);
        case 14:
            return new Tickets_Audit_Prop(13, []);
        case 15:
            return new Tickets_Audit_Prop(14, []);
        case 16:
            return new Tickets_Audit_Prop(15, []);
        case 17:
            return new Tickets_Audit_Prop(16, []);
        case 18:
            return new Tickets_Audit_Prop(17, []);
        case 19:
            return new Tickets_Audit_Prop(18, []);
        case 20:
            return new Tickets_Audit_Prop(20, []);
        case 21:
            return new Tickets_Audit_Prop(21, []);
        case 22:
            return new Tickets_Audit_Prop(22, []);
        case 23:
            return new Tickets_Audit_Prop(23, []);
        case 24:
            return new Tickets_Audit_Prop(24, []);
        case 25:
            return new Tickets_Audit_Prop(25, []);
        case 26:
            return new Tickets_Audit_Prop(26, []);
        case 27:
            return new Tickets_Audit_Prop(19, []);
        default:
            return undefined;
    }
}

export function Tickets_Audit_Prop_FromUnionColumnId_Z524259A4(columnId) {
    switch (columnId) {
        case 6:
            return new Tickets_Audit_Prop(5, []);
        case 7:
            return new Tickets_Audit_Prop(6, []);
        case 8:
            return new Tickets_Audit_Prop(7, []);
        case 9:
            return new Tickets_Audit_Prop(8, []);
        case 10:
            return new Tickets_Audit_Prop(9, []);
        case 14:
            return new Tickets_Audit_Prop(13, []);
        case 19:
            return new Tickets_Audit_Prop(18, []);
        default:
            return undefined;
    }
}

/**
 * Given the name of one of Ticket's properties, try to get its AuditProp column id. This is sent to
 * AuditLogs.compareProperties to get the correct column id when storing the change in the database.
 */
export function Tickets_Audit_tryToColumnId(propertyName) {
    return tryPick((union) => {
        if (name(union) === propertyName) {
            return Tickets_Audit_Prop_ToColumnId_182A0A5(makeUnion(union, []));
        }
        else {
            return undefined;
        }
    }, getUnionCases(Tickets_Audit_Prop_$reflection()));
}

